// Upstream: shadcn-ui/ui apps/v4/registry/new-york-v4/ui/button.tsx — MIT. Variants/sizes from @ahcut/ui/recipes (no cva).

import type { ComponentProps } from "react";
import { Slot } from "radix-ui";
import { buttonClass, type ButtonSize, type ButtonVariant } from "@ahcut/ui/recipes";
import { cn } from "@/lib/cn";

export interface ButtonProps extends ComponentProps<"button"> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  /** Style the single child (router <Link>, <a>) as the button instead of rendering a <button>. */
  asChild?: boolean;
}

export function Button({
  variant = "primary",
  size = "md",
  block = false,
  asChild = false,
  className,
  type,
  ...rest
}: ButtonProps) {
  const classes = cn(buttonClass({ variant, size, block }), className);
  // data-slot after the spread: print rules in styles.css hide [data-slot="button"].
  if (asChild) {
    return <Slot.Root {...rest} data-slot="button" className={classes} />;
  }
  return <button {...rest} data-slot="button" type={type ?? "button"} className={classes} />;
}
